import { useState } from "react";
import { enqueueSnackbar } from "notistack";

export const useAnswerFileUploader = ({ isIndependentUser, student = {} }) => {
  const [file, setFile] = useState(null);
  const [fileDialogOpen, setFileDialogOpen] = useState(false);
  const [identifier, setIdentifier] = useState(student);
  const handleFileUpload = (files) => {
    if (!files || files.length === 0) return;
    const file = files[0];

    const allowedExtensions = [".docx", ".pdf"];
    const matchedExt = allowedExtensions.find((ext) =>
      file.name.toLowerCase().endsWith(ext),
    );

    if (!matchedExt) {
      enqueueSnackbar("The file is not a Word doc or PDF!", {
        variant: "error",
      });
      return;
    }

    setFile(file);
    setFileDialogOpen(true);

    if (isIndependentUser) {
      setIdentifier({
        id: null,
        identifier: file.name.replace(matchedExt, ""),
      });
    }
  };

  return {
    file,
    setFile,
    fileDialogOpen,
    setFileDialogOpen,
    identifier,
    setIdentifier,
    handleFileUpload,
  };
};
